"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  DownloadButton: ['download-button', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.5,6.25a2,2,0,0,0-2,2v13a2,2,0,0,0,2,2h13a2,2,0,0,0,2-2v-13a2,2,0,0,0-2-2H16a1,1,0,0,0-1,1V9.513a.25.25,0,0,0,.273.249,2.49,2.49,0,0,1,2.186.935,2.6,2.6,0,0,1-.291,3.42l-3.4,3.4a2.5,2.5,0,0,1-3.536,0l-3.4-3.4a2.6,2.6,0,0,1-.291-3.42,2.49,2.49,0,0,1,2.186-.935A.25.25,0,0,0,9,9.513V7.25a1,1,0,0,0-1-1Z', 'M10.5,11a.25.25,0,0,1-.25.25H8.5a1,1,0,0,0-.707,1.707l3.5,3.5a1,1,0,0,0,1.414,0l3.5-3.5A1,1,0,0,0,15.5,11.25H13.75A.25.25,0,0,1,13.5,11V2.25a1.5,1.5,0,0,0-3,0Z']],
  DownloadCircle: ['download-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm4.748,14.664-4,4.5a1,1,0,0,1-1.5,0l-4-4.5A1,1,0,0,1,8,13h2.25a.25.25,0,0,0,.25-.25V5.5a1.5,1.5,0,0,1,3,0v7.25a.25.25,0,0,0,.25.25H16a1,1,0,0,1,.748,1.664Z']],
  DownloadDashArrow: ['download-dash-arrow', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.583,15.809a1,1,0,0,0,.184,1.08l6.16,6.634a1.462,1.462,0,0,0,2.146,0l6.16-6.634a1,1,0,0,0-.733-1.681H15.25a.25.25,0,0,1-.25-.25V10.507a1,1,0,0,0-1-1H10a1,1,0,0,0-1,1v4.451a.25.25,0,0,1-.25.25H5.5A1,1,0,0,0,4.583,15.809Z', 'M9.000 3.993 L15.000 3.993 L15.000 8.007 L9.000 8.007 Z', 'M9.000 0.007 L15.000 0.007 L15.000 2.493 L9.000 2.493 Z']],
  DownloadSquare: ['download-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.286,0H1.714A1.716,1.716,0,0,0,0,1.714V22.285A1.716,1.716,0,0,0,1.714,24H22.286A1.716,1.716,0,0,0,24,22.285V1.714A1.716,1.716,0,0,0,22.286,0ZM9.551,7.347h4.9a.489.489,0,0,1,.49.489v.98a.49.49,0,0,1-.49.49h-4.9a.49.49,0,0,1-.49-.49v-.98A.489.489,0,0,1,9.551,7.347ZM9.061,4.9v-.98a.49.49,0,0,1,.49-.49h4.9a.49.49,0,0,1,.49.49V4.9a.489.489,0,0,1-.49.489h-4.9A.489.489,0,0,1,9.061,4.9Zm.49,6.367h4.9a.49.49,0,0,1,.49.49v1.709a.25.25,0,0,0,.25.25H16.9a.844.844,0,0,1,.633,1.529l-4.492,4.492a1.47,1.47,0,0,1-2.078,0L6.469,15.243A.844.844,0,0,1,7.1,13.714H8.811a.25.25,0,0,0,.25-.25V11.755A.49.49,0,0,1,9.551,11.265Z']],
  DownloadSquare3: ['download-square-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2,2.25A.25.25,0,0,1,2.25,2H3.5a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V3.5a1,1,0,0,0,2,0Z', 'M24,2a2,2,0,0,0-2-2H20.5a1,1,0,0,0,0,2h1.25a.25.25,0,0,1,.25.25V3.5a1,1,0,0,0,2,0Z', 'M10,0H7.5a1,1,0,0,0,0,2H10a1,1,0,0,0,0-2Z', 'M16.5,0H14a1,1,0,0,0,0,2h2.5a1,1,0,0,0,0-2Z', 'M7.5,24H10a1,1,0,0,0,0-2H7.5a1,1,0,0,0,0,2Z', 'M16.5,22H14a1,1,0,0,0,0,2h2.5a1,1,0,0,0,0-2Z', 'M2,24H3.5a1,1,0,0,0,0-2H2.25A.25.25,0,0,1,2,21.75V20.5a1,1,0,0,0-2,0V22A2,2,0,0,0,2,24Z', 'M24,22V20.5a1,1,0,0,0-2,0v1.25a.25.25,0,0,1-.25.25H20.5a1,1,0,0,0,0,2H22A2,2,0,0,0,24,22Z', 'M2,7.5a1,1,0,0,0-2,0V10a1,1,0,0,0,2,0Z', 'M1,13a1,1,0,0,0-1,1v2.5a1,1,0,0,0,2,0V14A1,1,0,0,0,1,13Z', 'M24,7.5a1,1,0,0,0-2,0V10a1,1,0,0,0,2,0Z', 'M24,14a1,1,0,0,0-2,0v2.5a1,1,0,0,0,2,0Z', 'M11.876,5a1.5,1.5,0,0,0-1.5,1.5V12a.25.25,0,0,1-.25.25h-2.5a.75.75,0,0,0-.612,1.183l4.251,6a.748.748,0,0,0,.6.317h.01a.753.753,0,0,0,.6-.3l4.5-6a.75.75,0,0,0-.6-1.2H13.626a.25.25,0,0,1-.25-.25V6.5A1.5,1.5,0,0,0,11.876,5Z']],
  DownloadSquare1: ['download-square-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.286,0H1.714A1.716,1.716,0,0,0,0,1.714V22.285A1.716,1.716,0,0,0,1.714,24H22.286A1.716,1.716,0,0,0,24,22.285V1.714A1.716,1.716,0,0,0,22.286,0ZM9.551,8.816h4.9a.49.49,0,0,1,.49.49v4.158a.25.25,0,0,0,.25.25H16.9a.844.844,0,0,1,.633,1.529l-4.492,4.492a1.473,1.473,0,0,1-2.078,0L6.469,15.243A.844.844,0,0,1,7.1,13.714H8.811a.25.25,0,0,0,.25-.25V9.306A.49.49,0,0,1,9.551,8.816Zm-.49-2.449V3.918a.49.49,0,0,1,.49-.49h4.9a.49.49,0,0,1,.49.49V6.367a.49.49,0,0,1-.49.49h-4.9A.49.49,0,0,1,9.061,6.367Z']],
  DownloadThickBox: ['download-thick-box', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.964,4.941a.251.251,0,0,0,.047.213.248.248,0,0,0,.2.1h9.777A.251.251,0,0,0,11.235,5L11.164.246A.249.249,0,0,0,10.914,0H4.653A2.588,2.588,0,0,0,2.367,1.526L1.192,4.2A5.731,5.731,0,0,0,.964,4.941Z', 'M12.985,5.25h9.807a.248.248,0,0,0,.2-.1.251.251,0,0,0,.047-.213,5.731,5.731,0,0,0-.228-.741c-.012-.029-.025-.058-.039-.085l-1.316-2.56A2.6,2.6,0,0,0,19.153,0H12.915a.249.249,0,0,0-.25.253L12.735,5A.251.251,0,0,0,12.985,5.25Z', 'M.75,7V22a2,2,0,0,0,2,2h18.5a2,2,0,0,0,2-2V7A.25.25,0,0,0,23,6.75H1A.25.25,0,0,0,.75,7Zm5.793,8.048A.5.5,0,0,1,7,14.75H8.75A.25.25,0,0,0,9,14.5V9.75a.5.5,0,0,1,.5-.5h4.75a.5.5,0,0,1,.5.5V14.5a.25.25,0,0,0,.25.25h1.75a.5.5,0,0,1,.378.827l-4.75,5.5a.5.5,0,0,1-.372.173H12a.5.5,0,0,1-.37-.164l-5-5.5A.5.5,0,0,1,6.543,15.048Z']],
  HarddriveDownload1: ['harddrive-download-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.549,5.646a.25.25,0,0,1-.25.25H8.6a.976.976,0,0,0-.69,1.667l3.416,3.416a.977.977,0,0,0,1.381,0L16.12,7.563A.976.976,0,0,0,15.43,5.9h-1.7a.25.25,0,0,1-.25-.25V1.469a1.465,1.465,0,0,0-2.929,0Z', 'M20.812,14.2H3.187A2.94,2.94,0,0,0,.25,17.14v3.917A2.941,2.941,0,0,0,3.187,24H20.812a2.941,2.941,0,0,0,2.938-2.938V17.14A2.94,2.94,0,0,0,20.812,14.2Zm-15.911,5a.735.735,0,0,1,.734-.735H9.252a.735.735,0,1,1,0,1.469H5.635A.734.734,0,0,1,4.9,19.207Zm13.953,1.361A1.469,1.469,0,1,1,20.323,19.1,1.471,1.471,0,0,1,18.854,20.568Z']],
  HarddriveDownload2: ['harddrive-download-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.854,14.2H5.146a4.9,4.9,0,0,0,0,9.792H18.854a4.9,4.9,0,0,0,0-9.792Zm0,6.365A1.469,1.469,0,1,1,20.323,19.1,1.471,1.471,0,0,1,18.854,20.568ZM4.563,19.1a.734.734,0,0,1,.734-.735H9.062a.735.735,0,1,1,0,1.469H5.3A.734.734,0,0,1,4.563,19.1Z', 'M10.522,5.646a.25.25,0,0,1-.25.25H8.57a.976.976,0,0,0-.69,1.667L11.3,10.979a.977.977,0,0,0,1.381,0l3.416-3.416A.976.976,0,0,0,15.4,5.9H13.7a.25.25,0,0,1-.25-.25V1.469a1.465,1.465,0,0,0-2.929,0Z']],
  HarddriveUpload: ['harddrive-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.5,16.5h21a.5.5,0,0,0,.3-.9l-4-3a.507.507,0,0,0-.3-.1H5.5a.507.507,0,0,0-.3.1l-4,3a.5.5,0,0,0,.3.9Z', 'M22.5,18H1.5A1.5,1.5,0,0,0,0,19.5v3A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5v-3A1.5,1.5,0,0,0,22.5,18ZM20,22.5A1.5,1.5,0,1,1,21.5,21,1.5,1.5,0,0,1,20,22.5Z', 'M10.643,5.619a.25.25,0,0,0-.25-.25H8.69A.977.977,0,0,1,8,3.7L11.417.286a.975.975,0,0,1,1.38,0L16.214,3.7a.976.976,0,0,1-.69,1.667h-1.7a.25.25,0,0,0-.25.25V9.8a1.464,1.464,0,0,1-2.928,0Z']],
  HarddriveUpload1: ['harddrive-upload-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.643,5.619a.25.25,0,0,0-.25-.25H8.69A.977.977,0,0,1,8,3.7L11.417.286a.975.975,0,0,1,1.38,0L16.214,3.7a.976.976,0,0,1-.69,1.667h-1.7a.25.25,0,0,0-.25.25V9.8a1.464,1.464,0,0,1-2.928,0Z', 'M21,14H3a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V17A3,3,0,0,0,21,14ZM4.75,19.11a.75.75,0,0,1,.75-.75H9a.75.75,0,0,1,0,1.5H5.5A.75.75,0,0,1,4.75,19.11ZM19,20.5A1.5,1.5,0,1,1,20.5,19,1.5,1.5,0,0,1,19,20.5Z']],
  UploadThickBox: ['upload-thick-box', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.208,5.25h9.777A.249.249,0,0,0,11.235,5L11.164.246A.25.25,0,0,0,10.914,0H4.653A2.588,2.588,0,0,0,2.367,1.526L1.192,4.2a5.731,5.731,0,0,0-.228.741.253.253,0,0,0,.047.214A.25.25,0,0,0,1.208,5.25Z', 'M12.735,5a.251.251,0,0,0,.25.246h9.807a.25.25,0,0,0,.2-.095.253.253,0,0,0,.047-.214,5.731,5.731,0,0,0-.228-.741c-.012-.029-.025-.057-.039-.085L21.453,1.556A2.6,2.6,0,0,0,19.153,0H12.915a.249.249,0,0,0-.25.254Z', 'M.75,7V22a2,2,0,0,0,2,2h18.5a2,2,0,0,0,2-2V7A.25.25,0,0,0,23,6.75H1A.25.25,0,0,0,.75,7Zm8,9a.745.745,0,0,1,.67-.413h1a.25.25,0,0,0,.25-.25v-4.75a1.5,1.5,0,0,1,3,0v4.75a.249.249,0,0,0,.25.25h1a.751.751,0,0,1,.6,1.2l-2.752,3.667a.751.751,0,0,1-1.2,0L8.817,16.783h0A.748.748,0,0,1,8.747,16Z']],
  DownloadArrow: ['download-arrow', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.332,14.084a.944.944,0,0,0,1.336,0L21.64,5.112A.944.944,0,0,0,20.972,3.5H19.556a.944.944,0,0,0-.668.276l-6.534,6.535a.5.5,0,0,1-.708,0L5.112,3.776A.944.944,0,0,0,4.444,3.5H3.028A.944.944,0,0,0,2.36,5.112Z', 'M22.389,17.666H1.611a1.417,1.417,0,0,0,0,2.834H22.389a1.417,1.417,0,1,0,0-2.834Z']],
  DownloadArrow2: ['download-arrow-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,15.574a2.354,2.354,0,0,0,4.062-.1L21.67,3.215a1.411,1.411,0,0,0-1.2-2.156h-.942a1.412,1.412,0,0,0-1.2.671l-5.9,9.59a.5.5,0,0,1-.852,0l-5.9-9.59a1.412,1.412,0,0,0-1.2-.671H3.529a1.411,1.411,0,0,0-1.2,2.156Z', 'M22.353,19.647H1.647a1.647,1.647,0,1,0,0,3.294H22.353a1.647,1.647,0,0,0,0-3.294Z']],
  DownloadButtonAlternate: ['download-button-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,6.5H16a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h2.25a.25.25,0,0,1,.25.25v12.5a.25.25,0,0,1-.25.25H5.75a.25.25,0,0,1-.25-.25V8.749a.25.25,0,0,1,.25-.25H8a1,1,0,0,0,1-1H9a1,1,0,0,0-1-1H5.5a2,2,0,0,0-2,2v13a2,2,0,0,0,2,2h13a2,2,0,0,0,2-2V8.5A2,2,0,0,0,18.5,6.5Z', 'M11.293,16.706a1,1,0,0,0,1.414,0l3.5-3.5A1,1,0,0,0,15.5,11.5H13.75a.25.25,0,0,1-.25-.25V2a1.5,1.5,0,0,0-3,0v9.25a.25.25,0,0,1-.25.25H8.5a1,1,0,0,0-.707,1.707Z']],
  UploadButtonAlternate: ['upload-button-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,9a2,2,0,0,0-2-2H16a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h2.25a.25.25,0,0,1,.25.25v12.5a.25.25,0,0,1-.25.25H5.75a.25.25,0,0,1-.25-.25V9.249A.25.25,0,0,1,5.75,9H8A1,1,0,0,0,9,8H9A1,1,0,0,0,8,7H5.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h13a2,2,0,0,0,2-2Z', 'M10.5,13.5a1.5,1.5,0,1,0,3,0V5.749a.25.25,0,0,1,.25-.25H15.5a1,1,0,0,0,.707-1.707l-3.5-3.5a1,1,0,0,0-1.414,0l-3.5,3.5A1,1,0,0,0,8.5,5.5h1.75a.25.25,0,0,1,.25.25Z']],
  UploadBottom: ['upload-bottom', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,19.59a4.039,4.039,0,0,0,4.035,4.035h15.93A4.039,4.039,0,0,0,24,19.59V17.716a1.225,1.225,0,1,0-2.449,0V19.59a1.588,1.588,0,0,1-1.586,1.586H4.035A1.588,1.588,0,0,1,2.449,19.59V17.716a1.225,1.225,0,1,0-2.449,0Z', 'M12,19.322a1.959,1.959,0,0,0,1.959-1.959V8.2a.25.25,0,0,1,.25-.25H16.9a.979.979,0,0,0,.739-1.622L12.739.7a1.011,1.011,0,0,0-1.478,0l-4.9,5.633A.979.979,0,0,0,7.1,7.951H9.791a.25.25,0,0,1,.25.25v9.162A1.959,1.959,0,0,0,12,19.322Z']],
  MonitorUpload: ['monitor-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,6.5a2,2,0,0,0-2-2H18.917a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1H20.25a.25.25,0,0,1,.25.25v10a.25.25,0,0,1-.25.25H3.75a.25.25,0,0,1-.25-.25v-10a.25.25,0,0,1,.25-.25H4.917a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3.5a2,2,0,0,0-2,2v12a2,2,0,0,0,2,2h7.25a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25h-5a1,1,0,0,0,0,2h12.5a1,1,0,0,0,0-2h-5a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25H20.5a2,2,0,0,0,2-2Z', 'M7.493,4.883a1,1,0,0,0,.924.617h1.75a.25.25,0,0,1,.25.25V11a1.5,1.5,0,0,0,3,0V5.75a.249.249,0,0,1,.25-.25h1.75a1,1,0,0,0,.707-1.707l-3.5-3.5a1,1,0,0,0-1.415,0l-3.5,3.5A1,1,0,0,0,7.493,4.883Z']],
  UploadButton: ['upload-button', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.5,7a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h13a2,2,0,0,0,2-2V9a2,2,0,0,0-2-2h-2a1,1,0,0,0-1,1v5.408a3.556,3.556,0,0,1-2.771,3.518A3.5,3.5,0,0,1,8.5,13.5V8a1,1,0,0,0-1-1Z', 'M10.5,13.5a1.5,1.5,0,0,0,3,0V5.75a.25.25,0,0,1,.25-.25H15.5a1,1,0,0,0,.707-1.707l-3.5-3.5a1,1,0,0,0-1.414,0l-3.5,3.5A1,1,0,0,0,8.5,5.5h1.75a.25.25,0,0,1,.25.25Z']],
  UploadCircle: ['upload-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm4.912,10.409A1,1,0,0,1,16,11H13.75a.25.25,0,0,0-.25.25V18.5a1.5,1.5,0,0,1-3,0V11.25a.25.25,0,0,0-.25-.25H8a1,1,0,0,1-.748-1.664l4-4.5a1.032,1.032,0,0,1,1.5,0l4,4.5A1,1,0,0,1,16.912,10.409Z']],
  MonitorDownload: ['monitor-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.3,20.541a1.952,1.952,0,0,0,1.952-1.952V6.875A1.952,1.952,0,0,0,20.3,4.922H16.88A.976.976,0,0,0,15.9,5.9h0a.976.976,0,0,0,.976.976h3.168a.25.25,0,0,1,.25.25v9.75a.25.25,0,0,1-.25.25H3.952a.25.25,0,0,1-.25-.25V7.125a.25.25,0,0,1,.25-.25H7.119A.976.976,0,0,0,8.1,5.9h0a.976.976,0,0,0-.976-.977H3.7A1.952,1.952,0,0,0,1.75,6.875V18.589A1.952,1.952,0,0,0,3.7,20.541h7.072a.25.25,0,0,1,.25.25v.965a.25.25,0,0,1-.25.25H5.9a.976.976,0,0,0,0,1.952H18.1a.976.976,0,1,0,0-1.952H13.226a.25.25,0,0,1-.25-.25v-.965a.25.25,0,0,1,.25-.25Z', 'M10.535,8.577a.25.25,0,0,1-.25.25h-1.7a.976.976,0,0,0-.69,1.667l3.416,3.416a.977.977,0,0,0,1.381,0l3.416-3.416a.976.976,0,0,0-.69-1.667h-1.7a.25.25,0,0,1-.25-.25V1.506a1.465,1.465,0,1,0-2.929,0Z']],
  UploadBox: ['upload-box', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.208,5.25h9.777A.249.249,0,0,0,11.235,5L11.164.246A.25.25,0,0,0,10.914,0H4.653A2.588,2.588,0,0,0,2.367,1.526L1.192,4.2a5.731,5.731,0,0,0-.228.741.253.253,0,0,0,.047.214A.25.25,0,0,0,1.208,5.25Z', 'M12.985,5.25h9.807a.25.25,0,0,0,.2-.095.253.253,0,0,0,.047-.214,5.731,5.731,0,0,0-.228-.741c-.012-.029-.025-.057-.039-.085L21.453,1.556A2.6,2.6,0,0,0,19.153,0H12.915a.249.249,0,0,0-.25.254L12.735,5A.251.251,0,0,0,12.985,5.25Z', 'M.75,7V22a2,2,0,0,0,2,2h18.5a2,2,0,0,0,2-2V7A.25.25,0,0,0,23,6.75H1A.25.25,0,0,0,.75,7Zm5.88,7.914,5-5.5a.747.747,0,0,1,.376-.164.5.5,0,0,1,.372.173l4.75,5.5a.5.5,0,0,1-.378.827H15a.25.25,0,0,0-.25.25v4.75a.5.5,0,0,1-.5.5H9.5a.5.5,0,0,1-.5-.5V16a.25.25,0,0,0-.25-.25H7a.5.5,0,0,1-.37-.836Z']],
  UploadSquare: ['upload-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.286,24A1.716,1.716,0,0,0,24,22.285V1.714A1.716,1.716,0,0,0,22.286,0H1.714A1.716,1.716,0,0,0,0,1.714V22.285A1.716,1.716,0,0,0,1.714,24ZM9.551,8.816h4.9a.49.49,0,0,1,.49.49v4.158a.25.25,0,0,0,.25.25H16.9a.844.844,0,0,1,.633,1.529l-4.492,4.492a1.473,1.473,0,0,1-2.078,0L6.469,15.243A.844.844,0,0,1,7.1,13.714H8.811a.25.25,0,0,0,.25-.25V9.306A.49.49,0,0,1,9.551,8.816Zm-.49-2.449V3.918a.49.49,0,0,1,.49-.49h4.9a.49.49,0,0,1,.49.49V6.367a.49.49,0,0,1-.49.49h-4.9A.49.49,0,0,1,9.061,6.367Z']],
  UploadThickBottom: ['upload-thick-bottom', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.616,17.273a1.455,1.455,0,0,0,1.454,1.454h3.392a1.455,1.455,0,0,0,1.453-1.454V9.045a.25.25,0,0,1,.25-.25h2.9a1.138,1.138,0,0,0,.827-2L12.794.7a1.489,1.489,0,0,0-2.056,0L4.64,6.8a1.137,1.137,0,0,0,.827,2h2.9a.249.249,0,0,1,.25.25Z', 'M0,19.677a4.039,4.039,0,0,0,4.035,4.035h15.93A4.039,4.039,0,0,0,24,19.677V17.8a1.225,1.225,0,0,0-2.449,0v1.874a1.588,1.588,0,0,1-1.586,1.586H4.035a1.588,1.588,0,0,1-1.586-1.586V17.8A1.225,1.225,0,0,0,0,17.8Z']],
  UploadSquare1: ['upload-square-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.286,0H1.714A1.716,1.716,0,0,0,0,1.714V22.285A1.716,1.716,0,0,0,1.714,24H22.286A1.716,1.716,0,0,0,24,22.285V1.714A1.716,1.716,0,0,0,22.286,0ZM14.449,16.653h-4.9a.49.49,0,0,1-.49-.49v-.98a.489.489,0,0,1,.49-.489h4.9a.489.489,0,0,1,.49.489v.98A.49.49,0,0,1,14.449,16.653Zm.49,2.449v.979a.49.49,0,0,1-.49.49h-4.9a.49.49,0,0,1-.49-.49V19.1a.49.49,0,0,1,.49-.49h4.9A.49.49,0,0,1,14.939,19.1Zm-.49-6.368h-4.9a.489.489,0,0,1-.49-.489v-1.71a.25.25,0,0,0-.25-.25H7.1a.915.915,0,0,1-.941-.506.913.913,0,0,1,.308-1.022l4.492-4.493a1.473,1.473,0,0,1,2.078,0l4.492,4.493a.913.913,0,0,1,.308,1.022.915.915,0,0,1-.941.506H15.189a.25.25,0,0,0-.25.25v1.71A.489.489,0,0,1,14.449,12.734Z']],
  UploadSquare2: ['upload-square-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.975,11.336a.75.75,0,0,1,.071-.786l4.5-6a.749.749,0,0,1,.6-.3h.01a.751.751,0,0,1,.6.316l4.251,6A.751.751,0,0,1,16.4,11.75H13.9a.25.25,0,0,0-.25.25v5.5a1.5,1.5,0,0,1-3,0V12a.25.25,0,0,0-.25-.25H7.646A.75.75,0,0,1,6.975,11.336Z', 'M17.229,22h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M6.771,24h1a1,1,0,1,0,0-2h-1a1,1,0,0,0,0,2Z', 'M11.521,22a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M17.271,0h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M7.771,0h-1a1,1,0,0,0,0,2h1a1,1,0,1,0,0-2Z', 'M11.521,2h1a1,1,0,0,0,0-2h-1a1,1,0,0,0,0,2Z', 'M.021,17.25a1,1,0,0,0,2,0v-1a1,1,0,0,0-2,0Z', 'M1.021,8.75a1,1,0,0,0,1-1v-1a1,1,0,0,0-2,0v1A1,1,0,0,0,1.021,8.75Z', 'M.021,12.5a1,1,0,0,0,2,0v-1a1,1,0,0,0-2,0Z', 'M22.979,15.25a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0v-1A1,1,0,0,0,22.979,15.25Z', 'M23.021,5.75a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0v-1A1,1,0,0,0,23.021,5.75Z', 'M23.021,10.5a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0v-1A1,1,0,0,0,23.021,10.5Z', 'M22.979,20a1,1,0,0,0-1,1v.75a.25.25,0,0,1-.25.25h-.75a1,1,0,0,0,0,2h1a2,2,0,0,0,2-2V21A1,1,0,0,0,22.979,20Z', 'M2.979,22h-.75a.25.25,0,0,1-.25-.25V21a1,1,0,0,0-2,0v1a2,2,0,0,0,2,2h1a1,1,0,0,0,0-2Z', 'M21.979,0h-1a1,1,0,0,0,0,2h.75a.25.25,0,0,1,.25.25V3a1,1,0,0,0,2,0V2A2,2,0,0,0,21.979,0Z', 'M2.979,0h-1a2,2,0,0,0-2,2V3a1,1,0,0,0,2,0V2.25A.25.25,0,0,1,2.229,2h.75a1,1,0,0,0,0-2Z']],
  UploadSquare3: ['upload-square-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2,2.25A.25.25,0,0,1,2.25,2H3.5a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V3.5a1,1,0,0,0,2,0Z', 'M24,2a2,2,0,0,0-2-2H20.5a1,1,0,0,0,0,2h1.25a.25.25,0,0,1,.25.25V3.5a1,1,0,0,0,2,0Z', 'M10,0H7.5a1,1,0,0,0,0,2H10a1,1,0,0,0,0-2Z', 'M16.5,0H14a1,1,0,0,0,0,2h2.5a1,1,0,0,0,0-2Z', 'M7.5,24H10a1,1,0,0,0,0-2H7.5a1,1,0,0,0,0,2Z', 'M17.5,23a1,1,0,0,0-1-1H14a1,1,0,0,0,0,2h2.5A1,1,0,0,0,17.5,23Z', 'M2,24H3.5a1,1,0,0,0,0-2H2.25A.25.25,0,0,1,2,21.75V20.5a1,1,0,0,0-2,0V22A2,2,0,0,0,2,24Z', 'M24,22V20.5a1,1,0,0,0-2,0v1.25a.25.25,0,0,1-.25.25H20.5a1,1,0,0,0,0,2H22A2,2,0,0,0,24,22Z', 'M2,7.5a1,1,0,0,0-2,0V10a1,1,0,0,0,2,0Z', 'M1,13a1,1,0,0,0-1,1v2.5a1,1,0,0,0,2,0V14A1,1,0,0,0,1,13Z', 'M24,7.5a1,1,0,0,0-2,0V10a1,1,0,0,0,2,0Z', 'M24,14a1,1,0,0,0-2,0v2.5a1,1,0,0,0,2,0Z', 'M11.876,5h-.01a.75.75,0,0,0-.6.316l-4.251,6A.751.751,0,0,0,7.625,12.5h2.5a.25.25,0,0,1,.25.25v5.5a1.5,1.5,0,0,0,3,0v-5.5a.25.25,0,0,1,.25-.25h2.749a.75.75,0,0,0,.6-1.2l-4.5-6A.75.75,0,0,0,11.876,5Z']],
  DownloadBox: ['download-box', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.964,4.941a.253.253,0,0,0,.047.214.25.25,0,0,0,.2.095h9.777A.249.249,0,0,0,11.235,5L11.164.246A.25.25,0,0,0,10.914,0H4.653A2.588,2.588,0,0,0,2.367,1.526L1.192,4.2A5.731,5.731,0,0,0,.964,4.941Z', 'M12.985,5.25h9.807a.25.25,0,0,0,.2-.095.253.253,0,0,0,.047-.214,5.731,5.731,0,0,0-.228-.741c-.012-.029-.025-.057-.039-.085L21.453,1.556A2.6,2.6,0,0,0,19.153,0H12.915a.249.249,0,0,0-.25.254L12.735,5A.251.251,0,0,0,12.985,5.25Z', 'M.75,7V22a2,2,0,0,0,2,2h18.5a2,2,0,0,0,2-2V7A.25.25,0,0,0,23,6.75H1A.25.25,0,0,0,.75,7Zm8.065,6.385h0l2.75-3.666a.778.778,0,0,1,1.2,0l2.749,3.665a.75.75,0,0,1-.6,1.2h-1a.249.249,0,0,0-.25.25v4.749a1.5,1.5,0,0,1-3,0V14.834a.25.25,0,0,0-.25-.25h-1a.751.751,0,0,1-.6-1.2Z']],
  DownloadBrackets: ['download-brackets', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.8,0H17.388a1.225,1.225,0,1,0,0,2.449H21.3a.25.25,0,0,1,.25.25V21.3a.25.25,0,0,1-.25.25H17.388a1.225,1.225,0,1,0,0,2.449H21.8A2.207,2.207,0,0,0,24,21.8V2.2A2.207,2.207,0,0,0,21.8,0Z', 'M2.2,24H6.612a1.225,1.225,0,1,0,0-2.449H2.7a.25.25,0,0,1-.25-.25V2.7a.25.25,0,0,1,.25-.25H6.612A1.225,1.225,0,1,0,6.612,0H2.2A2.207,2.207,0,0,0,0,2.2V21.8A2.207,2.207,0,0,0,2.2,24Z', 'M12,4.653a1.469,1.469,0,0,0-1.469,1.469v5.733a.25.25,0,0,1-.25.25H7.1a.979.979,0,0,0-.739,1.622l4.9,5.633a.979.979,0,0,0,1.478,0l4.9-5.633a.979.979,0,0,0-.739-1.622H13.719a.25.25,0,0,1-.25-.25V6.122A1.469,1.469,0,0,0,12,4.653Z']],
  DownloadDashArrow1: ['download-dash-arrow-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15,9.031a.25.25,0,0,1,.25-.25H18.5A1,1,0,0,0,19.233,7.1L13.074.468a1.507,1.507,0,0,0-2.147,0L4.767,7.1A1,1,0,0,0,5.5,8.781H8.75a.25.25,0,0,1,.25.25v4.451a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1Z', 'M9.000 15.982 L15.000 15.982 L15.000 19.996 L9.000 19.996 Z', 'M9.000 21.496 L15.000 21.496 L15.000 23.982 L9.000 23.982 Z']],
  DownloadMenu: ['download-menu', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.45,1.608a1.45,1.45,0,1,0-2.9,0V6.675a.25.25,0,0,1-.25.25H8.617a.967.967,0,0,0-.684,1.65l3.384,3.383a.966.966,0,0,0,1.366,0l3.384-3.383a.967.967,0,0,0-.684-1.65H13.7a.25.25,0,0,1-.25-.25Z', 'M19.25,22.875a.966.966,0,0,0-.967-.967H5.717a.967.967,0,1,0,0,1.933H18.283A.966.966,0,0,0,19.25,22.875Z', 'M18.283,18.525H5.717a.967.967,0,1,0,0,1.933H18.283a.967.967,0,1,0,0-1.933Z', 'M18.283,15.141H5.717a.967.967,0,1,0,0,1.934H18.283a.967.967,0,0,0,0-1.934Z']],
  ExternalUpload: ['external-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.622,12.89a1.5,1.5,0,0,0-1.008-.39H6.387a1.5,1.5,0,0,0-1.009.39L1.729,16.207a.25.25,0,0,0,.227.428,4.453,4.453,0,0,1,.924-.123c.831-.024,17.7-.012,18.241,0a4.452,4.452,0,0,1,.923.123.25.25,0,0,0,.227-.428Z', 'M21,18H3a3,3,0,1,0,0,6H21a3,3,0,1,0,0-6ZM7,21.75H4a.75.75,0,0,1,0-1.5H7a.75.75,0,0,1,0,1.5Zm10.5.75A1.5,1.5,0,1,1,19,21,1.515,1.515,0,0,1,17.5,22.5Z', 'M10.643,5.619a.25.25,0,0,0-.25-.25h-1.7A.976.976,0,0,1,8,3.7L11.417.286a.977.977,0,0,1,1.381,0L16.214,3.7a.976.976,0,0,1-.69,1.666h-1.7a.25.25,0,0,0-.25.25V9.8a1.465,1.465,0,1,1-2.929,0Z']],
  HarddriveUpload2: ['harddrive-upload-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,14H5A5,5,0,0,0,5,24H19a5,5,0,0,0,0-10Zm0,6.5A1.5,1.5,0,1,1,20.5,19,1.5,1.5,0,0,1,19,20.5ZM4.4,19a.75.75,0,0,1,.75-.75H9a.75.75,0,0,1,0,1.5H5.154A.75.75,0,0,1,4.4,19Z', 'M12,11.5A1.5,1.5,0,0,0,13.5,10V5.75a.25.25,0,0,1,.25-.25H15.5a1,1,0,0,0,.707-1.707l-3.5-3.5a1,1,0,0,0-1.414,0l-3.5,3.5A1,1,0,0,0,8.5,5.5h1.75a.25.25,0,0,1,.25.25V10A1.5,1.5,0,0,0,12,11.5Z']],
  LaptopDownload: ['laptop-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,8v8a1,1,0,0,0,2,0V8a1,1,0,0,1,1-1H8A1,1,0,0,0,9,6H9A1,1,0,0,0,8,5H5.5A3,3,0,0,0,2.5,8Z', 'M18.5,7a1,1,0,0,1,1,1v8a1,1,0,0,0,2,0V8a3,3,0,0,0-3-3H16a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1Z', 'M6.74,24H17.26a7.076,7.076,0,0,0,6.714-4.842A.5.5,0,0,0,23.5,18.5H16a.5.5,0,0,0-.5.5c0,.708-1.5,1.5-3.5,1.5S8.5,19.708,8.5,19a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.474.658A7.076,7.076,0,0,0,6.74,24Z', 'M10.5,8.75a.25.25,0,0,1-.25.25H8.5a1,1,0,0,0-.708,1.707l3.5,3.5a1,1,0,0,0,1.415,0l3.5-3.5A1,1,0,0,0,15.5,9H13.75a.249.249,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0Z']],
  UploadDashArrow: ['upload-dash-arrow', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.583,15.809a1,1,0,0,0,.184,1.08l6.16,6.634a1.462,1.462,0,0,0,2.146,0l6.16-6.634a1,1,0,0,0-.733-1.681H15.25a.25.25,0,0,1-.25-.25V10.007a1,1,0,0,0-1-1H10a1,1,0,0,0-1,1v4.951a.25.25,0,0,1-.25.25H5.5A1,1,0,0,0,4.583,15.809Z', 'M9.000 4.507 L15.000 4.507 L15.000 7.507 L9.000 7.507 Z', 'M9.000 0.007 L15.000 0.007 L15.000 3.007 L9.000 3.007 Z']],
  ExternalDownload: ['external-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,13.118a1.472,1.472,0,0,0-.989-.382H6.5a1.475,1.475,0,0,0-.99.382l-3.564,3.24a.25.25,0,0,0,.226.429,5.794,5.794,0,0,1,1.006-.128H20.827a5.913,5.913,0,0,1,1.007.128.25.25,0,0,0,.226-.429Z', 'M20.827,18.13H3.173a2.942,2.942,0,0,0,0,5.884H20.827a2.942,2.942,0,0,0,0-5.884ZM7.1,21.808H4.154a.736.736,0,0,1,0-1.471H7.1a.736.736,0,1,1,0,1.471Zm11.771-.735A1.472,1.472,0,1,1,17.4,19.6,1.485,1.485,0,0,1,18.867,21.073Z', 'M11.289,10.96a.977.977,0,0,0,1.381,0l3.417-3.417A.976.976,0,0,0,15.4,5.877h-1.7a.25.25,0,0,1-.25-.25V1.45a1.465,1.465,0,0,0-2.929,0V5.627a.25.25,0,0,1-.25.25h-1.7a.976.976,0,0,0-.69,1.666Z']],
  UploadBrackets: ['upload-brackets', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.2A2.207,2.207,0,0,0,21.8,0H17.389a1.225,1.225,0,1,0,0,2.449H21.3a.25.25,0,0,1,.25.25V21.3a.25.25,0,0,1-.25.25H17.389a1.225,1.225,0,1,0,0,2.449H21.8A2.207,2.207,0,0,0,24,21.8Z', 'M0,2.2V21.8A2.207,2.207,0,0,0,2.2,24H6.613a1.225,1.225,0,1,0,0-2.449H2.7a.25.25,0,0,1-.25-.25V2.7a.25.25,0,0,1,.25-.25H6.613A1.225,1.225,0,1,0,6.613,0H2.2A2.207,2.207,0,0,0,0,2.2Z', 'M16.9,12.979a.979.979,0,0,0,.739-1.622l-4.9-5.633a1.011,1.011,0,0,0-1.478,0l-4.9,5.633A.979.979,0,0,0,7.1,12.979h3.179a.25.25,0,0,1,.25.25v5.488a1.469,1.469,0,1,0,2.938,0V13.229a.25.25,0,0,1,.25-.25Z']],
  DownloadArrow1: ['download-arrow-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.561,13.8a1.119,1.119,0,0,0,.09.1,1.91,1.91,0,0,0,2.7,0,1.119,1.119,0,0,0,.09-.1L20.4,4.463a.954.954,0,0,0-.766-1.523H4.371a.954.954,0,0,0-.766,1.523Z', 'M22.491,18.2H1.509a1.431,1.431,0,0,0,0,2.861H22.491a1.431,1.431,0,0,0,0-2.861Z']],
  HarddriveDownload: ['harddrive-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.281,18.12H1.719A1.47,1.47,0,0,0,.25,19.588v2.938A1.471,1.471,0,0,0,1.719,24H22.281a1.471,1.471,0,0,0,1.469-1.469V19.588A1.47,1.47,0,0,0,22.281,18.12ZM21.3,21.057a1.469,1.469,0,1,1-1.469-1.469A1.469,1.469,0,0,1,21.3,21.057Z', 'M22.575,15.769l-3.917-2.937a.483.483,0,0,0-.293-.1H5.635a.485.485,0,0,0-.293.1L1.425,15.769a.49.49,0,0,0,.294.882H22.281a.49.49,0,0,0,.294-.882Z', 'M10.567,5.646a.25.25,0,0,1-.25.25h-1.7a.977.977,0,0,0-.691,1.667l3.417,3.416a.975.975,0,0,0,1.38,0l3.417-3.416a.976.976,0,0,0-.69-1.667h-1.7a.249.249,0,0,1-.25-.25V1.469a1.465,1.465,0,0,0-2.929,0Z']],
  DownloadBottom: ['download-bottom', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.667,16.938a1.212,1.212,0,0,0-1.212,1.212v1.855a1.572,1.572,0,0,1-1.571,1.57H4.116a1.572,1.572,0,0,1-1.571-1.57V18.15a1.212,1.212,0,0,0-2.424,0v1.855a4,4,0,0,0,3.995,4H19.884a4,4,0,0,0,4-4V18.15A1.212,1.212,0,0,0,22.667,16.938Z', 'M12,0a1.939,1.939,0,0,0-1.939,1.939v9.066a.25.25,0,0,1-.25.25H7.152a.97.97,0,0,0-.732,1.606l4.848,5.576a.969.969,0,0,0,1.464,0l4.848-5.576a.97.97,0,0,0-.732-1.606H14.189a.25.25,0,0,1-.25-.25V1.939A1.939,1.939,0,0,0,12,0Z']],
  UploadMenu: ['upload-menu', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.423,16.383a1,1,0,0,0-.217-1.09l-3.5-3.5a1,1,0,0,0-1.414,0l-3.5,3.5A1,1,0,0,0,8.5,17h1.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V17.25a.25.25,0,0,1,.25-.25H15.5A1,1,0,0,0,16.423,16.383Z', 'M5.5,2h13a1,1,0,0,0,0-2H5.5a1,1,0,0,0,0,2Z', 'M5.5,5.5h13a1,1,0,0,0,0-2H5.5a1,1,0,0,0,0,2Z', 'M5.5,9h13a1,1,0,0,0,0-2H5.5a1,1,0,0,0,0,2Z']],
  DownloadSquare2: ['download-square-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.975,11.914a.75.75,0,0,0,.071.786l4.5,6a.752.752,0,0,0,.6.3h.01a.749.749,0,0,0,.6-.317l4.251-6A.75.75,0,0,0,16.4,11.5H13.9a.25.25,0,0,1-.25-.25V5.75a1.5,1.5,0,0,0-3,0v5.5a.25.25,0,0,1-.25.25H7.646A.75.75,0,0,0,6.975,11.914Z', 'M17.229,22h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M6.771,24h1a1,1,0,1,0,0-2h-1a1,1,0,0,0,0,2Z', 'M11.521,22a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M17.271,0h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M7.771,0h-1a1,1,0,0,0,0,2h1a1,1,0,1,0,0-2Z', 'M11.521,2h1a1,1,0,0,0,0-2h-1a1,1,0,0,0,0,2Z', 'M.021,17.25a1,1,0,0,0,2,0v-1a1,1,0,0,0-2,0Z', 'M1.021,8.75a1,1,0,0,0,1-1v-1a1,1,0,0,0-2,0v1A1,1,0,0,0,1.021,8.75Z', 'M.021,12.5a1,1,0,0,0,2,0v-1a1,1,0,0,0-2,0Z', 'M22.979,15.25a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0v-1A1,1,0,0,0,22.979,15.25Z', 'M23.021,5.75a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0v-1A1,1,0,0,0,23.021,5.75Z', 'M23.021,10.5a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0v-1A1,1,0,0,0,23.021,10.5Z', 'M22.979,20a1,1,0,0,0-1,1v.75a.25.25,0,0,1-.25.25h-.75a1,1,0,0,0,0,2h1a2,2,0,0,0,2-2V21A1,1,0,0,0,22.979,20Z', 'M2.979,22h-.75a.25.25,0,0,1-.25-.25V21a1,1,0,0,0-2,0v1a2,2,0,0,0,2,2h1a1,1,0,0,0,0-2Z', 'M21.979,0h-1a1,1,0,0,0,0,2h.75a.25.25,0,0,1,.25.25V3a1,1,0,0,0,2,0V2A2,2,0,0,0,21.979,0Z', 'M2.979,0h-1a2,2,0,0,0-2,2V3a1,1,0,0,0,2,0V2.25A.25.25,0,0,1,2.229,2h.75a1,1,0,0,0,0-2Z']],
  LaptopUpload: ['laptop-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.51,4.5H5.5a3,3,0,0,0-3,3v8a1,1,0,0,0,2,0v-8a1,1,0,0,1,1-1h.01a.991.991,0,0,0,.991-1V5.489A.992.992,0,0,0,5.51,4.5Z', 'M20.5,16.5a1,1,0,0,0,1-1v-8a3,3,0,0,0-3-3h-.013a.988.988,0,0,0-.99.978V5.5a.991.991,0,0,0,.991,1H18.5a1,1,0,0,1,1,1v8A1,1,0,0,0,20.5,16.5Z', 'M13.5,6.25A.25.25,0,0,1,13.75,6H15.5a1,1,0,0,0,.707-1.707l-3.5-3.5a1,1,0,0,0-1.414,0l-3.5,3.5A1,1,0,0,0,8.5,6h1.75a.25.25,0,0,1,.25.25V11.5a1.5,1.5,0,0,0,3,0Z', 'M23.5,18H16a.5.5,0,0,0-.5.5c0,.708-1.5,1.5-3.5,1.5s-3.5-.792-3.5-1.5A.5.5,0,0,0,8,18H.5a.5.5,0,0,0-.474.658A7.076,7.076,0,0,0,6.74,23.5H17.26a7.076,7.076,0,0,0,6.714-4.842A.5.5,0,0,0,23.5,18Z']],
  DownloadThickBottom: ['download-thick-bottom', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.616,1.741A1.455,1.455,0,0,1,10.07.287h3.392a1.455,1.455,0,0,1,1.453,1.454V9.969a.25.25,0,0,0,.25.25h2.9a1.138,1.138,0,0,1,.827,2l-6.1,6.1a1.489,1.489,0,0,1-2.056,0l-6.1-6.1a1.137,1.137,0,0,1,.827-2h2.9a.249.249,0,0,0,.25-.25Z', 'M0,19.677a4.039,4.039,0,0,0,4.035,4.035h15.93A4.039,4.039,0,0,0,24,19.677V17.8a1.225,1.225,0,0,0-2.449,0v1.874a1.588,1.588,0,0,1-1.586,1.586H4.035a1.588,1.588,0,0,1-1.586-1.586V17.8A1.225,1.225,0,0,0,0,17.8Z']],
  UploadDashArrow1: ['upload-dash-arrow-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15,9.031a.25.25,0,0,1,.25-.25H18.5A1,1,0,0,0,19.233,7.1L13.074.468a1.507,1.507,0,0,0-2.147,0L4.767,7.1A1,1,0,0,0,5.5,8.781H8.75a.25.25,0,0,1,.25.25v4.951a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1Z', 'M9.000 16.482 L15.000 16.482 L15.000 19.482 L9.000 19.482 Z', 'M9.000 20.982 L15.000 20.982 L15.000 23.982 L9.000 23.982 Z']]
};
exports["default"] = _default;